module.exports = __webpack_public_path__ + "fonts/uknumberplate-webfont.02064cf.woff";